// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Section_wrapper__HxVBC","top":"Section_top__vLDil","title":"Section_title__TR317","seeAllButton":"Section_seeAllButton__GhpaH","addButton":"Section_addButton__vXZAv"};